import React, { useMemo } from 'react';
import styled, {css} from 'styled-components';
import SbEditable from 'components/SbEditableExtended';

import WhiteBox from 'components/blocks/blockPartials/whiteBox';

import theme, {bp, color} from 'settings/theme';

import calculateBottomSpacingClass from 'components/blocks/utils/calculateBottomSpacingClass';
import multiOptionsToObject from 'components/blocks/utils/multiOptionsToObject';



// Component
const Component = (props) => {

  const displaySettings = useMemo(() => multiOptionsToObject(props.block?.display_settings), [props.block?.display_settings]);
  const spacingBottomClass = useMemo(() => calculateBottomSpacingClass(props.block?.bottom_spacing), [props.block?.bottom_spacing]);

  if(!props.block){
    return(<div>Storyblok block missing</div>);
  }

	return(
    <SbEditable content={props.block}>
    <StyledComponent {...props} className={`blockGoogleMap ${spacingBottomClass}`}>
        <WhiteBox removeWhiteBox={displaySettings.removeWhiteBox}>

          <div className="blockGoogleMap-map">
            <iframe
              frameBorder="0"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCRxBe-EOTm3aUzYPEIHOWt-v2TTUoPBCU&q=${props.block?.query}&zoom=${props.block.zoom_level ?? 10}`}
              allowFullScreen
              className="blockGoogleMap-map-gmap"
            >
            </iframe>
          </div>

          {props.block.caption &&
            <div className="blockGoogleMap-caption">
              {props.block.caption}
            </div>
          }

        </WhiteBox>
    </StyledComponent>
    </SbEditable>
	);

}

export default Component;


// Styles
const StyledComponent = styled.div`

  &:last-child{
    margin-bottom: 0;
  }

  .blockGoogleMap-map{

    width: 100%;
    height: 240px;
    background-color: ${color.grey(90)};

    .blockGoogleMap-map-gmap{
      width: 100%;
      height: 240px;
    }

  }

  .blockGoogleMap-caption{
    padding: 1rem 10vw;
    font-family: ${theme.typography.fontFamilySecondary};
    font-weight: bold;
    text-align: center;
  }


  @media (min-width: ${bp(3)}) {

    .blockGoogleMap-map{

      height: 400px;

      .blockGoogleMap-map-gmap{
        height: 400px;
      }

    }

  }

  @media (min-width: ${bp(5)}) {

  .blockGoogleMap-map{

      height: 500px;

      .blockGoogleMap-map-gmap{
          height: 500px;
      }

  }

}
`;